import { GlobalVariables } from '../../pdf/GlobalVariables';
import Command from './_Command';

export default class ZoomLevelButton extends Command {
  constructor(
    private readonly text: string,
    private readonly scale: number,
    private readonly path: string | false
  ) {
    super({
      'Enabled': true,
      'Key': `zoomLevel-${scale}`,
      'Path': path,
      'Text': text,
      'Callback': () => { 
        GlobalVariables.zoom(scale);
      },
    });
  }
}
